import type { ApiStorageTransaction } from '@Model';
import { EditFrameMode, type IEditFrame } from '@synqo/frontend-component-library';
import { StorageTransactionBookingBody } from './StorageTransactionBookingBody';
import { StorageTransactionViewBody } from './StorageTransactionViewBody';

interface IProps {
    frame: IEditFrame<ApiStorageTransaction>;
    /** What the server refused the booking for, shown at the fields of the booking mask. */
    rejection: string | undefined;
    /** Called after the stored booking shown was cancelled. */
    onCancelled?: () => void;
}

/** The booking mask for a draft, the read-only view for a stored booking. */
// @ai-generated 2026-10-23T17:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function StorageTransactionFrameBody({ frame, rejection, onCancelled }: IProps) {
    if (frame.mode === EditFrameMode.Create) {
        return <StorageTransactionBookingBody frame={frame} rejection={rejection} />;
    }

    return <StorageTransactionViewBody frame={frame} onCancelled={onCancelled} />;
}
